enum TransportJobsType {
  Haulage = 'Haulage',
  Digestate = 'Digestate'
}

export default TransportJobsType
